<template>
  <div class="empty-state" role="status">
    <span class="empty-state-icon" aria-hidden="true"
      ><slot name="icon">{{ icon }}</slot></span
    >
    <b class="empty-state-title">{{ title }}</b>
    <span v-if="text" class="empty-state-text">{{ text }}</span>
    <div v-if="$slots.action" class="empty-state-action">
      <slot name="action" />
    </div>
  </div>
</template>

<script>
export default {
  name: "EmptyState",
  props: {
    icon: { type: String, default: "+" },
    title: { type: String, required: true },
    text: { type: String, default: "" },
  },
};
</script>

<style scoped>
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.375rem;
  padding: 2rem 1rem;
  border: 1px dashed var(--pf-border);
  border-radius: 0.75rem;
  text-align: center;
}
.empty-state-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.75rem;
  height: 2.75rem;
  border-radius: 50%;
  background: var(--pf-accent-soft);
  font-size: 1.25rem;
  font-weight: 800;
  color: var(--pf-accent-dark);
}
.empty-state-icon :deep(svg) {
  width: 1.5rem;
  height: 1.5rem;
}
.empty-state-title {
  font-size: 0.9375rem;
}
.empty-state-text {
  max-width: 32rem;
  font-size: 0.8125rem;
  color: var(--pf-muted);
}
.empty-state-action {
  margin-top: 0.5rem;
}
</style>
